import {z} from '@hono/zod-openapi';

export const importNissanPriceListResponseSchema = z
  .object({
    messageId: z.string().openapi({example: 'a1b2c3d4-...'}),
  })
  .openapi('ImportNissanPriceListResponse');

export type ImportNissanPriceListResponse = z.infer<typeof importNissanPriceListResponseSchema>;
